import { USER_API } from "../../common/common";
import { postApi } from "../../service";

export const leagueNameCache: Record<string, any[] | undefined> = {};
export const leagueMatchCache: Record<string, any[] | undefined> = {};

const nameInflight: Record<string, Promise<any[]> | undefined> = {};
const matchInflight: Record<string, Promise<any[]> | undefined> = {};

function rememberNames(type: string, response: any) {
    const list = response?.data?.data?.sportLeageName || [];
    leagueNameCache[type] = list;
    return list;
}

export function refreshLeagueNames(type = "all") {
    const request = postApi({
        api: USER_API.LEAGUE_NAME,
        value: { type },
    })
        .then((response: any) => rememberNames(type, response))
        .catch(() => leagueNameCache[type] || [])
        .finally(() => {
            if (nameInflight[type] === request) delete nameInflight[type];
        });
    nameInflight[type] = request;
    return request;
}

export function fetchLeagueNames(type = "all") {
    const cached = leagueNameCache[type];
    if (cached) return Promise.resolve(cached);
    const pending = nameInflight[type];
    if (pending) return pending;
    return refreshLeagueNames(type);
}

export function prefetchLeagueNames() {
    ["all", "cricket", "soccer", "tennis"].forEach((type) => {
        fetchLeagueNames(type);
    });
}

export function fetchLeagueMatches(name: string): Promise<any[]> {
    if (!name) return Promise.resolve([]);
    const cached = leagueMatchCache[name];
    if (cached) return Promise.resolve(cached);
    const pending = matchInflight[name];
    if (pending) return pending;
    const request: Promise<any[]> = postApi({
        api: USER_API.SPORT_LISTBY_LEAGUE,
        value: { name },
    })
        .then((response: any) => {
            const list = response?.data?.data?.sportDetail || [];
            leagueMatchCache[name] = list;
            return list;
        })
        .catch(() => leagueMatchCache[name] || []);
    matchInflight[name] = request;
    request.finally(() => {
        if (matchInflight[name] === request) delete matchInflight[name];
    });
    return request;
}
